import React from "react";
import path from '../../../img/partners/ihodl.png'

const Ihodl: React.FunctionComponent = () => (
  <img src={path}/>
)

export default Ihodl
